import React from "react";
import { FooterData } from "../../fakeData/Footer";
import { Link } from "react-router-dom";
import LogoColor from "../../assets/icon/logo-color.png";
import PaymentImg from "../../assets/img/payment-logo.png";
function Footer() {
  return (
    <>
      <div className="">
       
      </div>
      <div className="border-t  border-gray-100 w-full">
        <div className="pb-16 lg:pb-0 xl-pb-0 bg-white">
          <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
            <div className="grid grid-cols-2 md:grid-cols-7 xl:grid-cols-12 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 py-10 lg:py-16 justify-between">
              {FooterData.map((data, index) => {
                return (
                  <div
                    key={index}
                    className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-4 lg:ml-20"
                  >
                    <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                      {data.titleHeader}
                    </h3>
                    <ul className="text-sm flex flex-col space-y-3" key={index}>
  {data.title.map((title, index) => (
    <li key={index} className="flex items-baseline">
      {title.href.startsWith("http") ? (
        <a
          className="!text-gray-600 inline-block w-full !no-underline hover:!text-emerald-500"
          href={title.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title.Name}
        </a>
      ) : (
        <Link
          className="!text-gray-600 inline-block w-full !no-underline hover:!text-emerald-500"
          to={title.href}
        >
          {title.Name}
        </Link>
      )}
    </li>
  ))}
</ul>

                  </div>
                );
              })}
              <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3 ">
                <Link to="/">
                  <span
                    style={{
                      boxSizing: "border-box",
                      display: "inline-block",
                      overflow: "hidden",
                      width: "initial",
                      height: "initial",
                      background: "none",
                      opacity: "1",
                      border: "0",
                      margin: "0",
                      padding: "0",
                      position: "relative",
                      maxWidth: "100%",
                    }}
                  >
                    <img className=" w-[150px] h-12" src={LogoColor} />
                  </span>
                </Link>

                <p className="text-center font-sans text-sm text-gray-600 ">
                
                  {/* <br />
                  <span>Tell: 02.356.1666</span> */}
                  <br />
                  {/* <span>pufframa@gmail.com</span> */}
                </p>
                <div className="col-span-1">
                  <span className="text-base leading-7 font-medium block mb-2 pb-0.5">
                    Follow Us
                  </span>
                  <ul className="text-sm flex">
                    <li className="flex items-center mr-3 transition ease-in-out duration-500">
                      <a
                        aria-label="Social Link"
                        rel="noreferrer"
                        target="_blank"
                        className="block text-center mx-auto text-gray-500 hover:text-white"
                        href="https://www.facebook.com"
                      >
                        <svg viewBox="0 0 64 64" width="34" height="34">
                          <circle
                            cx="32"
                            cy="32"
                            r="31"
                            fill="#3b5998"
                          ></circle>
                          <path
                            d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
                            fill="white"
                          ></path>
                        </svg>
                      </a>
                    </li>
                    <li className="flex items-center mr-3 transition ease-in-out duration-500">
                      <a
                        aria-label="Social Link"
                        rel="noreferrer"
                        target="_blank"
                        className="block text-center mx-auto text-gray-500 hover:text-white"
                        href="https://twitter.com"
                      >
                        <svg viewBox="0 0 64 64" width="34" height="34">
                          <circle
                            cx="32"
                            cy="32"
                            r="31"
                            fill="#00aced"
                          ></circle>
                          <path
                            d="M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
                            fill="white"
                          ></path>
                        </svg>
                      </a>
                    </li>
                    {/* <li className="flex items-center mr-3 transition ease-in-out duration-500">
                      <a
                        aria-label="Social Link"
                        rel="noreferrer"
                        target="_blank"
                        className="block text-center mx-auto text-gray-500 hover:text-white"
                        href="https://www.pinterest.com"
                      >
                        <svg viewBox="0 0 64 64" width="34" height="34">
                          <circle
                            cx="32"
                            cy="32"
                            r="31"
                            fill="#cb2128"
                          ></circle>
                          <path
                            d="M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z"
                            fill="white"
                          ></path>
                        </svg>
                      </a>
                    </li> */}


                    <li className="flex items-center mr-3 transition ease-in-out duration-500">
                      <a
                        aria-label="Social Link"
                        rel="noreferrer"
                        target="_blank"
                        className="block text-center mx-auto text-gray-500 hover:text-white"
                        href="https://www.linkedin.com"
                      >
                        <svg viewBox="0 0 64 64" width="34" height="34">
                          <circle
                            cx="32"
                            cy="32"
                            r="31"
                            fill="#007fb1"
                          ></circle>
                          <path
                            d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
                            fill="white"
                          ></path>
                        </svg>
                      </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
            <hr className="hr-line" />
        
          </div>
          <div className="mx-auto max-w-screen-2xl px-3 sm:px-10 flex justify-center py-4">
            <p className="text-sm text-gray-500 leading-6">
              Copyright 2025 @
              <span className="text-emerald-500">Pufframa</span>, All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
